import React, { useEffect, useState } from "react";
// import useRefreshToken from "../context/useRefreshToken";
// import useAuth from "../hooks/useAuth";
// import Loader from "./Loader/Loader";
import { Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useRefreshToken from "../context/useRefreshToken";

const PresistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { authenticated } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log(!authenticated?.accessToken, "no accesstoken found");
    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (error) {
        // console.log(error);

        navigate("/login");
      } finally {
        setIsLoading(false);
      }
    };
    !authenticated?.accessToken ? verifyRefreshToken() : setIsLoading(false);
  }, []);
  useEffect(() => {
    // console.log(`isLoading : ${isLoading}`);
    // console.log(`AT : ${JSON.stringify(authenticated?.accessToken)}`);
  });
  return (
    <>
      {isLoading ? (
        <>
          <p>Loading....</p>
          {/* <Loader /> */}
        </>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default PresistLogin;
